function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 24px;\n  padding: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 12px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a1a1a;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: #666;\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 16px;\n  border-top: 1px solid #e0e0e0;\n  font-size: 14px;\n  color: #888;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  background: #f0f0f0;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-weight: 500;\n  color: #555;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  font-size: 16px;\n  color: #666;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  background: #fff5f5;\n  border: 1px solid #fed7d7;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px;\n  color: #c53030;\n  text-align: center;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 20px;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 60px 20px;\n  color: #999;\n  font-size: 16px;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useGetRoadmapsInfinite } from '@edusense/course-client';
import styled from '@emotion/styled';
var RoadmapContainer = styled.div(_templateObject());
var RoadmapCard = styled.div(_templateObject1());
var RoadmapTitle = styled.h2(_templateObject2());
var RoadmapDescription = styled.p(_templateObject3());
var RoadmapMeta = styled.div(_templateObject4());
var CreatorInfo = styled.div(_templateObject5());
var CourseCount = styled.span(_templateObject6());
var LoadingContainer = styled.div(_templateObject7());
var ErrorContainer = styled.div(_templateObject8());
var LoadMoreTrigger = styled.div(_templateObject9());
var NoResultsMessage = styled.div(_templateObject10());
export var RoadmapListInfinite = function() {
    var _useInView = useInView({
        threshold: 0.1,
        rootMargin: '100px'
    }), loadMoreRef = _useInView.ref, inView = _useInView.inView;
    // Orval이 생성한 infinite scroll 훅 사용
    var _useGetRoadmapsInfinite = useGetRoadmapsInfinite({
        // API 파라미터
        page: 0,
        size: 12,
        sort: [
            'createdDate,desc'
        ],
        isPublic: true
    }, {
        // React Query 옵션
        query: {
            getNextPageParam: function(lastPage) {
                var _lastPage_data;
                // 마지막 페이지인지 확인
                var pageInfo = (_lastPage_data = lastPage.data) === null || _lastPage_data === void 0 ? void 0 : _lastPage_data.pagination;
                if (!pageInfo || pageInfo.page >= pageInfo.totalPages - 1) {
                    return undefined;
                }
                // 다음 페이지 번호 반환
                return pageInfo.page + 1;
            },
            initialPageParam: 0,
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000
        }
    }), data = _useGetRoadmapsInfinite.data, error = _useGetRoadmapsInfinite.error, isLoading = _useGetRoadmapsInfinite.isLoading, isError = _useGetRoadmapsInfinite.isError, isFetchingNextPage = _useGetRoadmapsInfinite.isFetchingNextPage, hasNextPage = _useGetRoadmapsInfinite.hasNextPage, fetchNextPage = _useGetRoadmapsInfinite.fetchNextPage;
    // 스크롤이 하단에 도달하면 다음 페이지 로드
    useEffect(function() {
        if (inView && hasNextPage && !isFetchingNextPage) {
            fetchNextPage();
        }
    }, [
        inView,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage
    ]);
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(LoadingContainer, null, "로드맵을 불러오는 중입니다...");
    }
    if (isError) {
        return /*#__PURE__*/ React.createElement(ErrorContainer, null, "로드맵을 불러오는 중 오류가 발생했습니다.", /*#__PURE__*/ React.createElement("br", null), error === null || error === void 0 ? void 0 : error.message);
    }
    var _data_pages_flatMap;
    // 모든 페이지의 로드맵들을 하나의 배열로 합치기
    var allRoadmaps = (_data_pages_flatMap = data === null || data === void 0 ? void 0 : data.pages.flatMap(function(page) {
        var _page_data;
        var _page_data_roadmaps;
        return (_page_data_roadmaps = (_page_data = page.data) === null || _page_data === void 0 ? void 0 : _page_data.roadmaps) !== null && _page_data_roadmaps !== void 0 ? _page_data_roadmaps : [];
    })) !== null && _data_pages_flatMap !== void 0 ? _data_pages_flatMap : [];
    if (allRoadmaps.length === 0) {
        return /*#__PURE__*/ React.createElement(NoResultsMessage, null, "아직 등록된 로드맵이 없습니다.");
    }
    return /*#__PURE__*/ React.createElement(RoadmapContainer, null, allRoadmaps.map(function(roadmap) {
        var _roadmap_creator, _roadmap_courseIds;
        return /*#__PURE__*/ React.createElement(RoadmapCard, {
            key: roadmap.id
        }, /*#__PURE__*/ React.createElement(RoadmapTitle, null, roadmap.title), /*#__PURE__*/ React.createElement(RoadmapDescription, null, roadmap.description || '설명이 없습니다.'), /*#__PURE__*/ React.createElement(RoadmapMeta, null, /*#__PURE__*/ React.createElement(CreatorInfo, null, /*#__PURE__*/ React.createElement("span", null, "\uD83D\uDC64"), /*#__PURE__*/ React.createElement("span", null, ((_roadmap_creator = roadmap.creator) === null || _roadmap_creator === void 0 ? void 0 : _roadmap_creator.name) || '알 수 없음')), /*#__PURE__*/ React.createElement(CourseCount, null, ((_roadmap_courseIds = roadmap.courseIds) === null || _roadmap_courseIds === void 0 ? void 0 : _roadmap_courseIds.length) || 0, " 코스")));
    }), /*#__PURE__*/ React.createElement(LoadMoreTrigger, {
        ref: loadMoreRef
    }, isFetchingNextPage && /*#__PURE__*/ React.createElement(LoadingContainer, null, "추가 로드맵을 불러오는 중..."), !hasNextPage && allRoadmaps.length > 0 && /*#__PURE__*/ React.createElement("div", {
        style: {
            color: '#999'
        }
    }, "모든 로드맵을 불러왔습니다.")));
};
export default RoadmapListInfinite;
